import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404011Status: 'idle',
    startProcess404011Error: undefined as any,
    loadUserParamsProcess404011Status: 'idle',
    loadUserParamsProcess404011Error: undefined as any,

    process404011List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404011 = createAsyncThunk('process404011Slice/startProcess404011', async ({ process404011 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404011/`,
        prepareData(process404011),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404011Status } = getState().process404011Slice
        return startProcess404011Status !== 'pending'
    }
})

export const loadUserParamsProcess404011 = createAsyncThunk('process404011Slice/loadUserParamsProcess404011', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404011/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404011Status } = getState().process404011Slice
        return loadUserParamsProcess404011Status !== 'pending'
    }
})

const Process404011Slice = createSlice({
    name: 'process404011Slice',
    initialState,
    reducers: {
        resetstartProcess404011: (state) => {
            state.job = undefined
            state.startProcess404011Error = undefined
        },
        resetstartProcess404011Error: (state) => {
            state.startProcess404011Error = undefined
        },
        resetloadUserParamsProcess404011: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404011Error = undefined
        },
        resetloadUserParamsProcess404011Error: (state) => {
            state.loadUserParamsProcess404011Error = undefined
        },
        removeFromProcess404011ListById: (state, action) => {
            state.process404011List = state.process404011List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404011ListByIds: (state, action) => {
            state.process404011List = state.process404011List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404011List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404011Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404011List = []
            state.startProcess404011Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404011.pending, (state) => {
            state.startProcess404011Status = 'pending'
            state.startProcess404011Error = undefined
        })
        builder.addCase(startProcess404011.fulfilled, (state, action) => {
            state.startProcess404011Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404011.rejected, (state, action) => {
            state.startProcess404011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404011Error = action.error.message
            } else {
                state.startProcess404011Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404011.pending, (state) => {
            state.loadUserParamsProcess404011Status = 'pending'
            state.loadUserParamsProcess404011Error = undefined
        })
        builder.addCase(loadUserParamsProcess404011.fulfilled, (state, action) => {
            state.loadUserParamsProcess404011Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404011.rejected, (state, action) => {
            state.loadUserParamsProcess404011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404011Error = action.error.message
            } else {
                state.loadUserParamsProcess404011Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404011,
    resetstartProcess404011Error,
    resetloadUserParamsProcess404011,
    resetloadUserParamsProcess404011Error,
    removeFromProcess404011ListById,
    removeFromProcess404011ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404011Slice.actions
export default Process404011Slice.reducer
